import { Component } from '@angular/core';
import {NavParams} from "ionic-angular";
import * as moment from 'moment';
import {Params} from "../../params";
import * as firebase from 'firebase/app';

@Component({
  selector: 'page-balance',
  templateUrl: 'balance.html',
})
export class BalancePage {
  customer;
  month;
  year;
  years = [];
  money = Params.money;
  actualMonth = [];
  totalCharges = 0;
  constructor(
    public params: NavParams) {
    this.customer = this.params.get("user");
    console.log(this.customer);
    let actual_year = Number(moment().format("YYYY"));
    let first_year = 2017;
    let end = (actual_year-first_year)+2;
    for(let y=0;y<end;y++){
      this.years.push(first_year+y);
    }

    this.month = moment().format("MM");
    this.year = actual_year;

    this.generateMonth();

  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad BalancePage');
  }

  generateMonth() {
    this.totalCharges = 0;
    const day_ref =this.month+"-15-"+this.year;
    console.log(day_ref);
    const startWeek = moment(day_ref).startOf('month').week();
    const endWeek = moment(day_ref).endOf('month').week();
    const calendar = [];
    for (let weekN = 0; weekN <= 5; weekN++) {
      const tempWeek = moment(day_ref).week(startWeek).add(weekN,'week');
      console.log(tempWeek.format(),tempWeek.week())
      const gWeek = this.generateWeek(tempWeek,this.month);
      calendar.push(gWeek);
    }
    this.actualMonth = calendar;
    console.log(this.actualMonth);
  }

  generateWeek(weekN, actualMonth) {
    const week = {
      week: weekN.week(),
      days: Array(7).fill(0).map((n, i) => {
        const tday = weekN.startOf('week').clone().add(n + i, 'day');

        const day = {
          loading: true,
          day: tday,
          thereAre : false,
          data : {},
        }
        if(tday.format('MM') === actualMonth){
          firebase.firestore().collection('orders').doc(tday.format('YYYYMMDD'))
            .collection('data').doc( Params.md5(this.customer.email))
            .get()
            .then((snap) => {
              day.loading = false;
              console.log(snap.data())
              day.thereAre = snap.exists;
              if(snap.exists){
                day.data = snap.data();
                this.totalCharges = this.totalCharges + this.customer.day_price;
              }
            })
        }else{
          day.loading = false;
        }

        return day;
      })
    };
    return week;
  }

  load(){
    this.generateMonth();
  }

}



// WEBPACK FOOTER //
// ./src/pages/customers/balance/balance.ts